import { FC } from "react";
import { CopayClaimsTabsConfig } from "./tabConfigs";
import CopayClaims from "src/components/copayClaims";
import { claimInitialState } from "./reducer";

const CopayClaimsHCPListing: FC = () => {
  return (
      <CopayClaims
          initialState={claimInitialState}
          tabs={CopayClaimsTabsConfig}
      />
  );
};

export default CopayClaimsHCPListing;
